import React from "react";
import withStyles from "react-jss";
import { CircleButton } from "ComponentsUI/SideWidgets";

const styles = () => {
    return {
        root: {},
    };
};

class FiltersWidget extends React.Component {
    render() {
        let classes = this.props.classes;
        return (
            <div
                className={classes.root}
                onClick={this.props.onClickHandler}
                datatest="filter_tariff_button"
            >
                <CircleButton whiteTheme={true}>
                    <span className="icon24 icon-config-1" />
                </CircleButton>
            </div>
        );
    }
}

export default withStyles(styles)(FiltersWidget);
